import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-concrete-900 py-16 sm:py-24" aria-labelledby="bonos" data-id="element-19" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-20" data-mp="avv122tdr0qw">
        <h2 id="bonos" className="font-display text-3xl uppercase leading-none text-concrete-50 sm:text-5xl" data-id="element-21" data-mp="at8vg8q1uvbb">
          Por solo $25 USD te llevas{' '}
          <span className="text-safety" data-id="element-22" data-mp="1t3p81wle2yq">5 bonos de regalo</span>
        </h2>
        <p className="mt-4 text-lg text-concrete-400" data-id="element-23" data-mp="5wrx6lp4z0ki">
          Valorados en más de{' '}
          <span className="font-bold text-concrete-200" data-id="element-24" data-mp="3o2n0lp033oew">$6,000 MXN</span>. Van
          incluidos, sin costo extra.
        </p>

        <ul className="mt-10 space-y-4" data-id="element-25" data-mp="3t0yd67hrkd0t">
          {bonuses.map(b => <li key={b.n} className="flex flex-col gap-4 border border-concrete-700 bg-concrete-950 p-6 sm:flex-row sm:items-start sm:gap-6" data-id="element-26" data-mp="1mbjqd0u3wbuv">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center bg-safety text-safety-ink" aria-hidden="true" data-id="element-27" data-mp="3idmwvrsjixdf">
                <GiftIcon className="h-6 w-6" data-id="element-28" data-mp="3r6i4ut9e776w" />
              </span>
              <div className="flex-1" data-id="element-29" data-mp="3r8ukgzroh5gs">
                <p className="font-display text-xs uppercase tracking-[0.2em] text-safety" data-id="element-30" data-mp="3n4mvr2l7zpik">
                  Bono {b.n}
                </p>
                <h3 className="mt-1 font-display text-xl uppercase leading-tight text-concrete-50 sm:text-2xl" data-id="element-31" data-mp="2zg3w1bg8kl23">
                  {b.title}
                </h3>
                <p className="mt-2 text-base leading-relaxed text-concrete-400" data-id="element-32" data-mp="38gs3tof1dp6j">
                  {b.text}
                </p>
              </div>
              <p className="flex shrink-0 items-baseline gap-2 whitespace-nowrap text-xs font-bold uppercase text-concrete-400 sm:block sm:text-right sm:text-sm" data-id="element-33" data-mp="33fukv9m7cr3z">
                Valor{' '}
                <span className="text-base text-concrete-200 line-through sm:block" data-id="element-34" data-mp="iqf12ylei2nu">
                  {b.value}
                </span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}